import { Injectable } from '@angular/core';
import { toDate } from '@macs-frontend/core/utils/date-utils';
import { BaseActionTeam } from '@macs-frontend/features/shared/models/action-team';
import * as fns from 'date-fns/fp';
import { function as F } from 'fp-ts';

@Injectable({
  providedIn: 'root',
})
export class ActionTeamHelperService {
  private readonly emptyText = 'not set';

  getActionTeamTime(
    team?: Pick<
      BaseActionTeam,
      | 'viaCompanyStartDate'
      | 'viaCompanyEndDate'
      | 'directToEventStartDate'
      | 'directToEventEndDate'
      | 'startDate'
      | 'endDate'
    >,
    showFor?: 'via-company' | 'direct-to-event',
  ): { start: string; end: string } {
    const [startDate, endDate] =
      showFor === 'via-company'
        ? [team?.viaCompanyStartDate, team?.viaCompanyEndDate]
        : showFor === 'direct-to-event'
        ? [team?.directToEventStartDate, team?.directToEventEndDate]
        : [team?.startDate, team?.endDate];

    if (!startDate || !endDate) {
      return { start: this.emptyText, end: this.emptyText };
    }

    return {
      start: F.pipe(startDate, toDate, fns.format('HH:mm')),
      end: F.pipe(endDate, toDate, fns.format('HH:mm')),
    };
  }
}
